<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!hasError">
  <ng-container *ngIf="!isLoading; else loading">
    <div class="layout">
      <!-- molecule List -->
      <aside>
        <div><p class="title">Genome</p></div>
        <div>
          <app-hce-stats-table
            [columnTitles]="cenomeDisplayedColumnLabels"
            [columnKeys]="cenomeDisplayedColumns"
            [data]="genomeListData"
          ></app-hce-stats-table>
        </div>
      </aside>
      <!-- molecule List -->
      <main class="right">
        <div><p class="title">Chromosome</p></div>
        <div>
          <app-hce-stats-table
            [columnTitles]="chromosomeDisplayedColumnLabels"
            [columnKeys]="chromosomeDisplayedColumns"
            [data]="chromosomeListData"
            (cellFilterRequest)="onCellFilterRequest($event)"
          ></app-hce-stats-table>
        </div>
      </main>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="loader" aria-live="polite" aria-busy="true">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</ng-container>
